import { Gift } from "lucide-react";

const inp = "w-full bg-white border-2 border-[color:var(--vt-dark)] px-3 py-2.5 text-sm focus:outline-none focus:border-[color:var(--vt-amber)]";
const lab = "block font-head uppercase text-xs tracking-wide text-[color:var(--vt-dark)] mb-1.5";

export default function GiftFields({ f, setF }) {
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  return (
    <div className="space-y-3">
      <label className="flex items-center gap-2 cursor-pointer select-none">
        <input data-testid="sk-in-gift" type="checkbox" checked={f.is_gift} onChange={(e) => setF((p) => ({ ...p, is_gift: e.target.checked }))} className="accent-[color:var(--vt-amber)] w-4 h-4" />
        <Gift size={16} className="text-[color:var(--vt-amber)]" />
        <span className="font-head uppercase text-xs tracking-wide">This is a gift for a volunteer coach</span>
      </label>
      {f.is_gift && (
        <div className="grid grid-cols-2 gap-4 border-l-4 border-[color:var(--vt-amber)] pl-3" data-testid="sk-gift-fields">
          <div><label className={lab} htmlFor="sk-buyer">Your name</label><input id="sk-buyer" data-testid="sk-in-buyer-name" maxLength={60} className={inp} value={f.buyer_name} onChange={set("buyer_name")} /></div>
          <div><label className={lab} htmlFor="sk-coach-email">Coach's email</label><input id="sk-coach-email" data-testid="sk-in-coach-email" type="email" className={inp} value={f.coach_email} onChange={set("coach_email")} /></div>
          <div className="col-span-2"><label className={lab} htmlFor="sk-note">Gift note (optional)</label>
            <textarea id="sk-note" data-testid="sk-in-gift-note" maxLength={300} rows={2} className={inp} value={f.gift_note} onChange={set("gift_note")} placeholder="Thanks for stepping up this season!" />
            <p className="text-[11px] text-right text-[color:var(--vt-graphite)]">{f.gift_note.length}/300</p></div>
        </div>
      )}
    </div>
  );
}
